import { CHANNEL_MODERATOR_PERMISSIONS } from '@onr/schema'

import { useAuthenticatedFirebaseUser } from '@/auth/useFirebaseUser'

const MODERATOR_PERMISSIONS: ReadonlySet<string> = new Set(CHANNEL_MODERATOR_PERMISSIONS)

export const useChannelModeration = (regionId: string) => {
  const { sys_admin: isSysAdmin, permissions, regionId: claimRegionId } = useAuthenticatedFirebaseUser()

  return {
    isSysAdmin,
    canModerate:
      isSysAdmin ||
      (claimRegionId === regionId && permissions.some((permission) => MODERATOR_PERMISSIONS.has(permission))),
  }
}
